import loadAutomaticRepliesBannerOptions from '../actions/loadAutomaticRepliesBannerOptions';
import loadMailboxAutomaticRepliesConfiguration from 'mini-options-store/lib/services/loadMailboxAutomaticRepliesConfiguration';
import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';
import setShouldShowAutomaticRepliesBanner from '../actions/setShouldShowAutomaticRepliesBanner';
import { orchestrator } from 'satcheljs';
import { shouldShowAutomaticRepliesBanner } from 'mini-options-store/lib/utils/automaticReplies/isAutomaticRepliesEnabledUtil';
import { trace } from 'owa-trace';

/**
 * Orchestrator to get the Auto reply config and set ShouldShowAutomaticRepliesBanner
 */
const loadAutomaticRepliesBannerOptionsOrchestrator = orchestrator(
    loadAutomaticRepliesBannerOptions,
    async () => {
        try {
            // get the automatic reply configuration from the server
            const mailboxAutoReplyConfiguration: MailboxAutoReplyConfigurationOptions = await loadMailboxAutomaticRepliesConfiguration();
            // update the view state
            setShouldShowAutomaticRepliesBanner(
                shouldShowAutomaticRepliesBanner(mailboxAutoReplyConfiguration)
            );
        } catch (e) {
            trace.warn(e.message || 'loadAutomaticRepliesBannerOptions failed');
        }
    }
);

export default loadAutomaticRepliesBannerOptionsOrchestrator;
